const RATE_TYPE_OPTIONS = [
  { value: "HOURLY", label: "Hourly" },
  { value: "DAILY", label: "Daily" },
  { value: "FIXED", label: "Fixed" },
];

export const CONSULTANT_SETUP_OPTIONS: Record<string, { value: string; label: string }[]> = {
  workMode: [
    { value: "REMOTE", label: "Remote" },
    { value: "ONSITE", label: "Onsite" },
    { value: "HYBRID", label: "Hybrid" },
  ],
  consultantPayRateType: RATE_TYPE_OPTIONS,
  caeliusBillRateType: RATE_TYPE_OPTIONS,
};
